import React from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import fakeAuth from '../../fakeAuth';
import config from '../../config';
import { Link } from 'react-router';
import eventBus from '../../redux-sagas/events/bus';

class TopRightMenu extends React.Component {
    state = {
        hotel: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')) : null,
        currency: localStorage.getItem('lb.currency') || 'USD',
    }
    onToggleCurrency = () => {
        let { currency } = this.state;
        if (currency === 'USD') currency = 'VEF';
        else currency = 'USD';
        this.setState({ currency });
        localStorage.setItem('lb.currency', currency);
        eventBus.emit('lb.event.currency_change', currency);
    }
    logout = () => {
        const { router } = this.props;
        fakeAuth.signout(() => {
            this.props.form_actions?.logout && this.props.form_actions.logout();
            router.push('/login');
        });
    }
    render() {
        let user = fakeAuth.getUser(), { currency } = this.state;
        return <div className="w-auto ms-auto d-flex align-self-center">
            <button onClick={this.onToggleCurrency} className="ms-auto d-flex align-items-center align-self-center bg-gray-dark pointer px-2" style={{ height: 28, borderRadius: 14, border: '1px solid gray', gap: 6 }}>
                <img src={`/images/flags/${currency}.png`} alt={currency} style={{ width: 18, height: 18, borderRadius: 9, objectFit: 'cover' }} />
                <span className="white poppins font-10">{currency}</span>
            </button>
            <div className="ms-2 align-self-center bg-gray-dark d-flex justify-content-center" style={{ width: 40, height: 40, borderRadius: 20, border: '1px solid gray' }}>
                <i className="fas fa-bell align-self-center whiteish font-14" />
            </div>
            <div className="ms-2 align-self-center cover" style={{ width: 40, height: 40, borderRadius: 20, border: '1px solid gray', background: `url(${user.LogoUrl}) no-repeat center center` }}></div>
            <button onClick={() => this.setState({ user_menu: !this.state.user_menu })} className="poppins d-flex btn btn-link align-self-center white font-10 ms-2" id="btn-user">{user.FirstName} {user.LastName.substring(0, 1)}. <i className="fa fa-chevron-down align-self-center ms-1" /></button>
            <Popover placement="bottom" isOpen={this.state.user_menu} target={`btn-user`} toggle={() => this.setState({ user_menu: !this.state.user_menu })} className="bg-gray-2">
                <PopoverBody className="d-flex flex-column justify-content-center">
                    {/*<button className="btn btn-link btn-sm white text-left"><i className="icon-lb_user me-2" />Mi Cuenta</button>*/}
                    <Link to={`/password`} className="btn btn-link btn-sm white text-left"><i className="icon-lock me-2" />Contraseña</Link>
                    {(user.Permissions & (config.permissions.SuperAdmin)) !== 0 && <Link to={this.state.hotel ? `/staff/${this.state.hotel.IdProperty}` : '/properties'} className="btn btn-link btn-sm white text-left"><i className="icon-lb_staff font-8 me-2" />Staff</Link>}
                    {(user.Permissions & (config.permissions.SuperAdmin)) !== 0 && <Link to="/properties" className="btn btn-link btn-sm white text-left"><i className="icon-lb_suitcase me-2" />Propiedades</Link>}
                    {(user.Permissions & (config.permissions.SuperAdmin)) !== 0 && <Link to={this.state.hotel ? `/logs/${this.state.hotel.IdProperty}` : '/properties'} className="btn btn-link btn-sm white text-left orange"><i className="icon-activity me-2" />Bitacora</Link>}
                    {/*<button className="btn btn-link btn-sm white text-left"><i className="icon-lb_cog me-2" />Ajustes</button>*/}
                    <button className="btn btn-link btn-sm white text-left" onClick={this.logout}><i className="icon-log-out me-2" />Cerrar Sesión</button>
                </PopoverBody>
            </Popover>
        </div>
    }
}

export default TopRightMenu;